import { twMerge } from "tailwind-merge";
import Typography from "@mui/material/Typography";
import type { TypographyProps } from "@mui/material/Typography";

const HEADING_SIZES = {
  sm: "text-base sm:text-lg",
  base: "text-lg sm:text-xl",
  md: "text-xl sm:text-2xl",
  lg: "text-2xl sm:text-3xl",
  xl: "text-3xl sm:text-4xl",
} as Record<string, string>;

type TextProps = TypographyProps & {
  children: React.ReactNode;
  className?: string;
  size?: "sm" | "base" | "md" | "lg" | "xl";
};

function Heading({
  children,
  className = "",
  size = "base",
  ...props
}: TextProps) {
  const mergedClasses = twMerge("font-bold", className, HEADING_SIZES[size]);

  return (
    <Typography className={mergedClasses} {...props}>
      {children}
    </Typography>
  );
}

export default Heading;
